import { Model } from 'src/containers/ProjectDiagram/types/model';
import { setLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { setRangesForAttributeModelData } from 'src/containers/ProjectDiagram/utils/modelConceptAttribute/setRangesForAttributeModelData';
import { setPropertyType } from 'src/containers/ProjectDiagram/utils/propertyType/setPropertyType';

export const addAttribute =
  ({
    value,
    text,
    ranges,
  }: {
    value: string;
    text: string;
    ranges: Array<{ value: string }>;
  }) =>
  (model: Model) => {
    setRangesForAttributeModelData(
      value,
      ranges.map((range) => range.value)
    )(model);
    setLabelForIri(value, text)(model);
    setPropertyType(value)(model);
  };
